export default function StatusRoute() {
	return <p>Status</p>
}
